module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright_first"
  }, [_vm._v("Copyright © 2009 Robin Prior")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("First printed in paperback 2010")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved. This book may not be reproduced in whole or in part, in any form (beyond that copying permitted by Sections 107 and 108 of the U.S. Copyright Law and except by reviewers for the public press) without written permission from the publishers.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("For information about this and other Yale University Press publications, please contact:")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("U.S. Office: "), _c('a', {
    attrs: {
      "href": "mailto:sales.press@yale.edu"
    }
  }, [_vm._v("sales.press@yale.edu")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.yalebooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.yalebooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Europe Office:  "), _c('a', {
    attrs: {
      "href": "mailto:sales@yaleup.co.uk"
    }
  }, [_vm._v("sales@yaleup.co.uk")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.yaleup.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.yaleup.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Set in Minion by IDSUK (DataConnection) Ltd.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Printed in Great Britain by MPG Books, Bodmin, Cornwall")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Prior, Robin.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-1"
  }, [_vm._v("Gallipoli : the end of the myth / Robin Prior.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-2"
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-1"
  }, [_vm._v("Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-1"
  }, [_vm._v("ISBN 978-0-300-14995-1 (ci : alk. Paper)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-1"
  }, [_vm._v("1.    World War, 1914–1918—Campaigns—Turkey—Gallipoli")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Peninsula. 2. Gallipoli Peninsula (Turkey)—History, Military. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-1"
  }, [_vm._v("D568.3.P76 2009")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-1"
  }, [_vm._v("940.4′26—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-r"
  }, [_vm._v("2008044682")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("A catalogue record for this book is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN 978–0–300–16894–5 (pbk)")]), _vm._v(" "), _c('p', {
    staticClass: "image-logo"
  }, [_c('img', {
    attrs: {
      "alt": "Gallipoli",
      "height": "144",
      "src": "images/logo.jpg",
      "width": "126"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("The paper used for the text pages of this book is FSC certified. FSC (The Forest Stewardship Council) is an international network to promote responsible management of the world's forests.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("10 9 8 7 6 5  4 3 2 1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-864f5876","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyright.vue
// module id = 66
// module chunks = 0